export const defaultVideoDuration = 5;
export const genVideoFromImageCmd = ({
  input,
  width,
  height,
  output,
}: {
  input: string;
  width: number;
  height: number;
  output: string;
}) => [
  '-loop',
  '1',
  '-i',
  input,
  // '-c:v',
  // 'libx264',
  '-t',
  defaultVideoDuration.toString(),
  // '-pix_fmt',
  // 'yuv420p',
  '-vf',
  `scale=${width}:${height}:force_original_aspect_ratio=decrease`,
  '-r',
  '1',
  output,
];
